export default {
  addEducate: "/employeeeducational/add", //添加教育信息API
  delEducate: "/employeeeducational/delete/{id}", //删除教育信息API
  editEducate: "/employeeeducational/modify", //更新教育信息列表API
  getEducate: "/employeeeducational/query/{id}", //获取教育信息列表API

  addFamily: "/employeefamily/add", //添加家庭成员API
  delFamily: "/employeefamily/delete/{id}", //删除家庭成员API
  editFamily: "/employeefamily/modify", //更新家庭成员列表API
  getFamily: "/employeefamily/query/{id}", //获取家庭成员列表API

  addWork: "/employeeworkexperiences/add", //添加工作经历信息API
  delWork: "/employeeworkexperiences/delete/{id}", //删除工作经历API
  editWork: "/employeeworkexperiences/modify", //更新工作经历列表API
  getWork: "/employeeworkexperiences/query/{id}", //获取工作经历列表API

  addContract: "/employeelabourcontract/add", //添加劳动合同信息API
  cancelContract: "/employeelabourcontract/cancel", //作废劳动合同API
  delContract: "/employeelabourcontract/delete/{id}", //删除劳动合同API
  editContract: "/employeelabourcontract/modify", //更新劳动合同列表API
  getContract: "/employeelabourcontract/query/{id}", //获取劳动合同列表
  getPrevTime: "/employeelabourcontract/getoldtime/{id}", //获取上次合同的结束时间API

  getEvaluate: "/talents/getinterviewassessment/{id}", //获取评价
  addEvaluate: "/talents/insertevaluate", //添加评价
  editEvaluate: "/talents/updatevaluate", //修改评价
}



// WEBPACK FOOTER //
// ./src/api/config/otherTable.js